<template>
  <v-form v-model="valid">
    <company-form
      v-model="form"
      :readonly="!editMode"
      :errors="errors.getAll()"
      @removeFile="addToBeRemoved"
      @update-prop="clearErrorByName($event)"
    >
    </company-form>
    <v-row dense>
      <v-col cols="12" class="pt-0">
        <div v-if="editMode">
          <v-btn
            outlined
            class="mr-5"
            depressed
            color="grey"
            large
            @click="cancel"
          >
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn
            depressed
            type="submit"
            :disabled="!valid"
            large
            color="primary"
            class="mr-5"
            @click.prevent="updateCompany"
          >
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { cloneDeep, isEqual } from 'lodash';
import { mapActions } from 'vuex';
import CompanyForm from '@/modules/companies/components/Company/CompanyForm';
import removeFile from '@/modules/_global/_components/Autouploadfile/mixins/removeFile';

export default {
  name: 'CompanyEdit',

  components: { CompanyForm },

  mixins: [errors, removeFile],

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {},
      valid: false,
      formCopy: null
    };
  },

  watch: {
    editMode: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v) {
          this.formCopy = cloneDeep(this.form);
        }
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler: function(formProps) {
        if (isEqual(formProps, this.form)) {
          return;
        }

        this.form = {
          ...this.form,
          ...formProps
        };

        this.emitter();
      }
    }
  },

  methods: {
    ...mapActions('company', ['update']),

    emitter() {
      this.$emit('input', this.form);
    },

    cancel() {
      if (
        this.form.upload_id &&
        this.form.upload_id !== this.formCopy.upload.id
      ) {
        this.sendDestroyRequest(this.form.upload.id);
      }
      if (this.form.logo_pdf_id !== this.formCopy.logo_pdf_id) {
        this.sendDestroyRequest(this.form.logo_pdf_id);
      }
      this.filterToBeRemovedIds([
        this.formCopy.logo_pdf_id,
        (this.formCopy.upload || {}).id
      ]);
      this.removeUnnecessaryFiles();
      this.form = cloneDeep(this.formCopy);
      this.$emit('cancel');
    },

    updateCompany() {
      this.update(this.form)
        .then(({ data }) => {
          this.filterToBeRemovedIds([
            this.formCopy.logo_pdf_id,
            (this.formCopy.upload || {}).id
          ]);
          this.removeUnnecessaryFiles();
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('update', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
